/* ══════════════════════════════════════════════════════════════════════
   Cookie 同意条。设计稿：新一版设计/cookie-preview.html

   ⚠️ **这支脚本存在的唯一理由是那个 API。**
   同意状态走 Shopify 的 Customer Privacy API
   （`Shopify.customerPrivacy.setTrackingConsent`）——
   Shopify 自己的分析和所有 Web Pixels 只听它。
   自己写一个只管显示的横幅、然后照旧加载像素，等于白做，还多一层法律风险。

   ⚠️ **要不要显示也由那个 API 说了算**（`shouldShowBanner()`）：
   已经表过态的人不该再被问一遍，而「问过没有」这件事只有 Shopify 知道 ——
   自己在 localStorage 里记一份，换个设备或者清了缓存就会打架。

   撤回同意（GDPR 7(3)）：页面上任何带 `data-ck-open` 的元素都能重新打开，
   页脚那一行就是它。也暴露 `window.EBCookie.open()` 给别处用。
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.ebCookieLoaded) return;
  window.ebCookieLoaded = true;

  var KEYS = ['analytics', 'marketing', 'preferences'];
  var root = null;

  /* ── Shopify 的同意 API ────────────────────────────────────────
     它不是默认加载的，得先 loadFeatures 才有。 */
  function withApi(cb) {
    if (window.Shopify && window.Shopify.customerPrivacy) return cb(window.Shopify.customerPrivacy);
    if (!window.Shopify || !window.Shopify.loadFeatures) return cb(null);
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (err) {
        cb(err ? null : (window.Shopify && window.Shopify.customerPrivacy) || null);
      }
    );
  }

  /* ── 量高度 ──
     产品页有吸底加购栏，两条都贴底会叠在一起。
     **盖住加购键的 cookie 条，损失可以直接换算成钱。** */
  function measure() {
    var h = root && !root.hidden ? root.getBoundingClientRect().height : 0;
    document.documentElement.style.setProperty('--ck-height', h + 'px');
  }

  function reads() {
    var out = {};
    KEYS.forEach(function (k) {
      var sw = root.querySelector('[data-ck-cat="' + k + '"]');
      out[k] = !!(sw && sw.getAttribute('aria-checked') === 'true');
    });
    return out;
  }

  function writes(map) {
    KEYS.forEach(function (k) {
      var sw = root.querySelector('[data-ck-cat="' + k + '"]');
      if (sw) sw.setAttribute('aria-checked', map[k] ? 'true' : 'false');
    });
  }

  function save(map) {
    withApi(function (api) {
      if (api && api.setTrackingConsent) {
        api.setTrackingConsent({
          analytics: !!map.analytics,
          marketing: !!map.marketing,
          preferences: !!map.preferences,
          /* CCPA 的那一项跟着营销走 —— 欧盟站用不到，但填了没有坏处，
             不填反而会在某些区域被当成未表态。 */
          sale_of_data: !!map.marketing
        }, close);
      } else {
        /* API 拿不到（脚本被拦、Shopify 改了接口）——
           **不能假装存下了**。让条留着，人还有机会再点一次；
           而更重要的是：没存下就说明像素也没被放行，默认仍然是安全的那一边。 */
        close();
      }
    });
  }

  function open(showPanel) {
    if (!root) return;
    root.hidden = false;
    var panel = root.querySelector('[data-ck-panel]');
    if (panel) panel.hidden = !showPanel;
    var more = root.querySelector('[data-ck="panel"]');
    if (more) more.textContent = showPanel ? more.dataset.tLess : more.dataset.tMore;
    measure();
  }

  function close() {
    if (!root) return;
    root.hidden = true;
    measure();
  }

  function boot(scope) {
    var el = (scope || document).querySelector('[data-cookie-bar]');
    if (el) root = el;
    if (!root) return;

    if (!root.dataset.bound) {
      root.dataset.bound = '1';

      root.addEventListener('click', function (e) {
        var sw = e.target.closest('[data-ck-cat]');
        if (sw && !sw.disabled) {
          sw.setAttribute('aria-checked', sw.getAttribute('aria-checked') === 'true' ? 'false' : 'true');
          return;
        }
        var b = e.target.closest('[data-ck]');
        if (!b) return;
        var a = b.dataset.ck;
        if (a === 'panel') { open(root.querySelector('[data-ck-panel]').hidden); return; }
        /* 「只要必要的」按下去**直接收起，不再确认一次** ——
           一个还要再点一次「确定」的拒绝，就不叫和接受一样容易了。 */
        if (a === 'essential') { writes({}); save({}); return; }
        if (a === 'all') {
          var all = {};
          KEYS.forEach(function (k) { all[k] = true; });
          writes(all);
          save(all);
          return;
        }
        if (a === 'save') { save(reads()); return; }
      });

      /* 任何地方的「Cookie 设置」都能重新打开，并**展开面板、显示上次的选择** ——
         从头再问一遍等于假装不记得，而我们明明记得。 */
      document.addEventListener('click', function (e) {
        if (!e.target.closest('[data-ck-open]')) return;
        e.preventDefault();
        withApi(function (api) {
          if (api && api.currentVisitorConsent) {
            var c = api.currentVisitorConsent() || {};
            writes({
              analytics: c.analytics === 'yes',
              marketing: c.marketing === 'yes',
              preferences: c.preferences === 'yes'
            });
          }
          open(true);
        });
      });

      window.addEventListener('resize', measure);
    }

    /* ⚠️ 问过没有由 Shopify 说了算 —— 自己记一份，换设备或清缓存就会打架 */
    withApi(function (api) {
      var should = true;
      try {
        if (api && typeof api.shouldShowBanner === 'function') should = api.shouldShowBanner();
      } catch (err) { should = true; }
      if (should) open(false);
      else close();
    });
  }

  window.EBCookie = { open: function () { open(true); }, close: close };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
